var map = {
	"./nature-1.svg": 66530,
	"./nature-2.svg": 21073,
	"./nature-3.svg": 58272,
	"./nature-4.svg": 16831,
	"./nature-5.svg": 95726,
	"assets/images/leads/nature/nature-1.svg": 66530,
	"assets/images/leads/nature/nature-2.svg": 21073,
	"assets/images/leads/nature/nature-3.svg": 58272,
	"assets/images/leads/nature/nature-4.svg": 16831,
	"assets/images/leads/nature/nature-5.svg": 95726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90665;